module.exports = __webpack_public_path__ + "static/media/was-logo.8b397652.png";